var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceTagPriceSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7315 1.26848C22.3735 0.910506 21.7931 0.910506 21.4351 1.26848L19.6335 3.07005L10.8613 4.32299C10.6649 4.35105 10.4829 4.44202 10.3427 4.58231L1.26846 13.6574C0.910484 14.0154 0.910527 14.5958 1.2685 14.9538L9.0465 22.7317C9.40447 23.0897 9.9849 23.0897 10.3429 22.7317L19.4171 13.6575C19.5573 13.5173 19.6483 13.3354 19.6764 13.1391L20.9303 4.36609L22.7316 2.56482C23.0895 2.20689 23.0895 1.6265 22.7315 1.26848ZM17.9047 12.5773L9.69469 20.7872L3.21303 14.3056L11.423 6.09474L18.9856 5.01458L17.9047 12.5773Z",
    fill: "#9393B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7494 11.0837C15.7623 11.0837 16.5828 10.2633 16.5828 9.25036C16.5828 8.2374 15.7623 7.41699 14.7494 7.41699C13.7365 7.41699 12.916 8.2374 12.916 9.25036C12.916 10.2633 13.7364 11.0837 14.7494 11.0837Z",
    fill: "#9393B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceTagPriceSvgrepocom);
export default __webpack_public_path__ + "static/media/price-tag-price_svgrepo.com.e8423a2da6a40ebcdc291a6adea3e279.svg";
export { ForwardRef as ReactComponent };